import { render, staticRenderFns } from "./EcommerceTemplate.vue?vue&type=template&id=1346fbba&scoped=true&"
import script from "./EcommerceTemplate.vue?vue&type=script&lang=js&"
export * from "./EcommerceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTemplate.vue?vue&type=style&index=0&id=1346fbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346fbba",
  null
  
)

export default component.exports